import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle2, XCircle } from "lucide-react";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("polling");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let cancelled = false;
    let attempts = 0;
    const poll = async () => {
      if (cancelled) return;
      attempts++;
      try {
        const r = await api.get(`/payments/status/${sessionId}`);
        if (r.data.payment_status === "paid") setStatus("paid");
        else if (r.data.payment_status === "failed" || r.data.payment_status === "expired") setStatus("failed");
        else if (attempts < 20) setTimeout(poll, 2000);
        else setStatus("timeout");
      } catch {
        if (attempts < 20) setTimeout(poll, 2000);
        else setStatus("timeout");
      }
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  return (
    <main className="max-w-lg mx-auto px-6 py-24 text-center" data-testid="payment-success">
      {status === "paid" ? (
        <>
          <CheckCircle2 className="w-16 h-16 text-emerald-500 mx-auto"/>
          <h1 className="font-heading text-3xl md:text-5xl mt-6 leading-tight text-[var(--agt-navy)]">Merci !</h1>
          <p className="mt-6 text-[var(--agt-ink-muted)] normal-case tracking-normal">Votre abonnement est actif. Nous vous contactons sous 24h pour finaliser votre fiche boutique.</p>
          <Link to="/" className="btn-primary mt-10">Retour à l'accueil</Link>
        </>
      ) : status === "polling" ? (
        <>
          <div className="w-16 h-16 border-4 border-[var(--agt-line)] border-t-[var(--agt-mustard)] rounded-full animate-spin mx-auto"/>
          <h1 className="font-heading text-2xl md:text-4xl mt-6 leading-tight text-[var(--agt-navy)]">Confirmation…</h1>
          <p className="mt-4 text-[var(--agt-ink-muted)] normal-case tracking-normal">Un instant.</p>
        </>
      ) : (
        <>
          <XCircle className="w-16 h-16 text-[var(--agt-ink-muted)] mx-auto"/>
          <h1 className="font-heading text-2xl md:text-4xl mt-6 leading-tight text-[var(--agt-navy)]">Paiement non confirmé</h1>
          <p className="mt-4 text-[var(--agt-ink-muted)] normal-case tracking-normal">Contactez-nous si le problème persiste.</p>
          <Link to="/abonnement" className="btn-ghost mt-8">Réessayer</Link>
        </>
      )}
    </main>
  );
}

export function PaymentCancel() {
  return (
    <main className="max-w-lg mx-auto px-6 py-24 text-center" data-testid="payment-cancel">
      <XCircle className="w-16 h-16 text-[var(--agt-ink-muted)] mx-auto"/>
      <h1 className="font-heading text-2xl md:text-4xl mt-6 leading-tight text-[var(--agt-navy)]">Paiement annulé</h1>
      <p className="mt-4 text-[var(--agt-ink-muted)] normal-case tracking-normal">Aucun montant n'a été débité.</p>
      <Link to="/abonnement" className="btn-primary mt-8">Reprendre</Link>
    </main>
  );
}
